export enum ValidationMode {
  /*
   * immediate will start showing validations messages as soon as the
   * element renders
   */
  Immediate = "immediate",
  /*
   * onFirstInteraction will start showing validation messages at different
   * times for different elements
   * - for HTMLTextAreaElement it is after the first blur
   * - for HTMLSelectElement it is after the first onChange or blur
   * - for HTMLInputElement it is the first enter key press or blur
   */
  OnFirstInteraction = "onFirstInteraction",
}
